export const sortDataByOrdered = (rawData: any[]) =>
  [...rawData].sort((a, b) => {
    // Sort by ordered first (true → false)
    if (a.ordered !== b.ordered) return a.ordered ? -1 : 1;
    // If equal, sort by id
    return a.id - b.id;
  });
